// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f2b376e1","373":"65b61283","551":"f2d2329d","734":"6ad4d7fd","889":"badf2d17"}[chunkId] + ".chunk.js";
};